export type ApiErrorCode =
  | 'UNAUTHORIZED'
  | 'FORBIDDEN'
  | 'NOT_FOUND'
  | 'VALIDATION_ERROR'
  | 'NETWORK_ERROR'
  | 'SERVER_ERROR'
  | 'TOKEN_EXPIRED'
  | 'UNKNOWN';

export type ApiError = {
  message: string;
  code: ApiErrorCode;
  statusCode: number;
  details?: Record<string, unknown>;
};

export type ApiResult<T> =
  | { success: true; data: T }
  | { success: false; error: ApiError };

export type PaginatedResponse<T> = {
  forms: T[];
  totalPages: number;
  currentPage: number;
};

export function createApiSuccess<T>(data: T): ApiResult<T> {
  return { success: true, data };
}

export function createApiError(
  message: string,
  code: ApiErrorCode,
  statusCode: number,
  details?: Record<string, unknown>
): ApiResult<never> {
  return {
    success: false,
    error: { message, code, statusCode, details },
  };
}

export function isApiError<T>(
  result: ApiResult<T>
): result is { success: false; error: ApiError } {
  return !result.success;
}

export function getErrorCodeFromStatus(status: number): ApiErrorCode {
  switch (status) {
    case 401:
      return 'UNAUTHORIZED';
    case 403:
      return 'FORBIDDEN';
    case 404:
      return 'NOT_FOUND';
    case 422:
      return 'VALIDATION_ERROR';
    case 500:
    case 502:
    case 503:
      return 'SERVER_ERROR';
    default:
      return 'UNKNOWN';
  }
}
